const Settings = ({ colour, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="38"
    height="40"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
    viewBox="0 0 38 40"
    {...props}
  >
    <defs>
      <path
        id="settings-a"
        d="m29.316 11.738 3.174.626h.035c.313.057.568.37.568.695v2.943a.73.73 0 0 1-.568.695l-3.117.614a11.13 11.13 0 0 1-1.193 2.955l1.75 2.607a.718.718 0 0 1-.082.892l-2.085 2.086c-.22.22-.626.255-.893.081l-2.572-1.726c-.927.556-1.935.985-3.013 1.263l-.185.961-.406 2.063c-.057.313-.37.568-.695.568h-2.943a.73.73 0 0 1-.695-.568l-.406-2.063-.185-.961a11.362 11.362 0 0 1-3.013-1.263l-2.572 1.726a.716.716 0 0 1-.892-.081l-2.086-2.086c-.22-.22-.255-.625-.081-.892l1.75-2.607a10.83 10.83 0 0 1-1.194-2.955L4.6 16.697a.73.73 0 0 1-.568-.695v-2.943c0-.325.255-.638.568-.695l3.175-.626A10.789 10.789 0 0 1 8.98 8.899L7.161 6.188a.718.718 0 0 1 .081-.893L9.328 3.21c.22-.221.625-.255.892-.081l2.746 1.853a10.689 10.689 0 0 1 2.781-1.147l.637-3.267A.73.73 0 0 1 17.079 0h2.944a.73.73 0 0 1 .695.568l.637 3.267c.985.267 1.924.649 2.781 1.147l2.746-1.853a.716.716 0 0 1 .892.081l2.086 2.085c.22.221.255.626.081.893l-1.83 2.711a11.24 11.24 0 0 1 1.205 2.839Zm-17.903 2.908a7.117 7.117 0 0 0 7.115 7.115 7.116 7.116 0 0 0 7.114-7.115c0-3.928-3.198-7.114-7.114-7.114-3.917 0-7.115 3.186-7.115 7.114Zm23.963 1.356v-2.445h.011a18.396 18.396 0 0 1 1.692 7.694c0 10.243-8.296 18.539-18.539 18.539C8.296 39.79 0 31.494 0 21.251c0-2.746.614-5.353 1.692-7.694v2.445c0 .765.313 1.483.811 2.028a16.303 16.303 0 0 0 4.461 14.773c1.843 1.851 4.129 1.136 6.684.335 1.541-.482 3.18-.995 4.88-.995 1.7 0 3.34.512 4.881.993 2.555.797 4.84 1.51 6.683-.333a16.267 16.267 0 0 0 4.473-14.773 3.025 3.025 0 0 0 .811-2.028Z"
      ></path>
    </defs>
    <use fill={colour} xlinkHref="#settings-a"></use>
  </svg>
);
export default Settings;
